var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLabValues(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3819_13056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2304 2.47061H5.63785C4.90966 2.47061 4.31934 3.20802 4.31934 4.11767V17.2941C4.31934 18.2038 4.90966 18.9412 5.63785 18.9412H12.2304C12.9586 18.9412 13.549 18.2038 13.549 17.2941V4.11767C13.549 3.20802 12.9586 2.47061 12.2304 2.47061Z",
    fill: "url(#paint0_linear_3819_13056)",
    stroke: "black",
    strokeWidth: 0.75678
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9335 1.15277H12.6261C12.262 1.15277 11.9668 1.52148 11.9668 1.9763V24.2116C11.9668 24.6664 12.262 25.0351 12.6261 25.0351H14.9335C15.2976 25.0351 15.5927 24.6664 15.5927 24.2116V1.9763C15.5927 1.52148 15.2976 1.15277 14.9335 1.15277Z",
    fill: "url(#paint1_linear_3819_13056)",
    stroke: "black",
    strokeWidth: 0.75678
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.726 7.41182L1.41859 18.1177C1.41859 18.1177 1.39662 18.9412 1.35267 20.5883C1.30871 22.2353 1.30871 23.0589 1.35267 23.0589C1.39662 23.0589 2.45143 23.6079 4.51711 24.7059C6.58278 25.804 9.43957 25.255 13.0875 23.0589V18.1177L10.7801 7.41182H3.726Z",
    fill: "url(#paint2_linear_3819_13056)",
    stroke: "black",
    strokeWidth: 0.75678
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3819_13056",
    x1: 4.31934,
    y1: 2.47061,
    x2: 4.31934,
    y2: 18.9412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFFF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3819_13056",
    x1: 11.9668,
    y1: 1.15277,
    x2: 11.9668,
    y2: 25.0351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FFC0CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3819_13056",
    x1: 1.3197,
    y1: 7.41182,
    x2: 1.3197,
    y2: 25.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#87CEEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3819_13056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1407,
    height: 28,
    fill: "white",
    transform: "translate(0.429688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabValues);
export default __webpack_public_path__ + "static/media/LabValues.93401bbf.svg";
export { ForwardRef as ReactComponent };